export const SET_PASSENGERS = 'SET_PASSENGERS';
export const SET_AVALIABLE_EXTRAS = 'SET_AVALIABLE_EXTRAS';
export const SET_RESERVATION = 'SET_RESERVATION_RESERVE';
export const SET_RESERVATION_STATUS = 'SET_RESERVATION_STATUS';
export const SET_AGE_TO_PASSENGER = 'SET_AGE_TO_PASSENGER';
export const SET_LOADING = 'SET_LOADING';
export const SET_RESERVATION_CODE = 'SET_RESERVATION_CODE';
export const SET_VALID_CODE_TO_TRUE = 'SET_VALID_CODE_TO_TRUE';
export const SET_APPEND_ICON = 'SET_APPEND_ICON';
export const SET_PASSENGERS_FILLED = 'SET_PASSENGERS_FILLED';
export const SET_BOARDING_PASSES = 'SET_BOARDING_PASSES';
export const SET_ONLY_SHOW_PASSPORT_OPTION = 'SET_ONLY_SHOW_PASSPORT_OPTION';
export const TOGGLE_PASSENGER_BAG = 'TOGGLE_PASSENGER_BAG';
export const SET_NEW_PASSENGERS = 'SET_NEW_PASSENGERS';
export const TOGGLE_EXTRA = 'TOGGLE_EXTRA';
export const SET_EXTRA_QUANTITY = 'SET_EXTRA_QUANTITY';



